import type { IconName } from "@similarweb/icons";

interface Item {
    id: string;
    text: string;
    tooltip: string;
    basic?: string;
    starter?: string;
    basicIcon?: IconName;
    starterIcon?: IconName;
}

export const TableData: Item[] = [
    {
        id: "0",
        text: "pro.purchase.plan.data.table.data.text.1",
        basic: "pro.purchase.plan.data.table.data.basic.1",
        starter: "pro.purchase.plan.data.table.data.starter.1",
        tooltip: "pro.purchase.plan.data.table.data.tooltip.1",
    },
    {
        id: "1",
        text: "pro.purchase.plan.data.table.data.text.2",
        basic: "pro.purchase.plan.data.table.data.basic.2",
        starter: "pro.purchase.plan.data.table.data.starter.2",
        tooltip: "pro.purchase.plan.data.table.data.tooltip.2",
    },
    {
        id: "2",
        text: "pro.purchase.plan.data.table.data.text.3",
        basic: "pro.purchase.plan.data.table.data.basic.2",
        starter: "pro.purchase.plan.data.table.data.starter.3",
        tooltip: "pro.purchase.plan.data.table.data.tooltip.3",
    },
    {
        id: "3",
        text: "pro.purchase.plan.data.table.data.text.4",
        basic: "pro.purchase.plan.data.table.data.basic.3",
        starter: "pro.purchase.plan.data.table.data.starter.4",
        tooltip: "pro.purchase.plan.data.table.data.tooltip.4",
    },
    {
        id: "4",
        text: "pro.purchase.plan.data.table.data.text.5",
        basicIcon: "locked2",
        starterIcon: "open",
        tooltip: "pro.purchase.plan.data.table.data.tooltip.5",
    },
    {
        id: "5",
        text: "pro.purchase.plan.data.table.data.text.6",
        basicIcon: "locked2",
        starterIcon: "open",
        tooltip: "pro.purchase.plan.data.table.data.tooltip.6",
    },
    {
        id: "6",
        text: "pro.purchase.plan.data.table.data.text.7",
        basicIcon: "locked2",
        starterIcon: "open",
        tooltip: "pro.purchase.plan.data.table.data.tooltip.7",
    },
    {
        id: "7",
        text: "pro.purchase.plan.data.table.data.text.8",
        basicIcon: "locked2",
        starterIcon: "open",
        tooltip: "pro.purchase.plan.data.table.data.tooltip.8",
    },
];

export const BulletsLeft = [
    "pro.after.trial.hook.popup.left.bullets.1",
    "pro.after.trial.hook.popup.left.bullets.2",
    "pro.after.trial.hook.popup.left.bullets.3",
];

export const RightBulletsKeys = [
    "pro.after.trial.hook.popup.right.bullets.1",
    "pro.after.trial.hook.popup.right.bullets.2",
    "pro.after.trial.hook.popup.right.bullets.3",
    "pro.after.trial.hook.popup.right.bullets.4",
];

export const availableCurrencies = ["USD"];

export const CURRENCY = "USD";
